<template>
  <div class="video">
    <v-card @click="dialog = true" tile flat>
      <img
        :src="`https://i3.ytimg.com/vi/${getYoutubeCode(
          video
        )}/maxresdefault.jpg`"
        class="d-block item-img"
        width="100%"
      />

      <div class="d-flex align-center justify-center item-caption">
        <v-icon color="#ffffff" size="50"> fa-play-circle </v-icon>
      </div>
    </v-card>

    <v-dialog content-class="video-content" v-model="dialog" max-width="960">
      <div class="position relative">
        <v-btn class="close-dialog-button" @click="dialog = false" small fab>
          <v-icon color="primary"> fa-times </v-icon>
        </v-btn>
        <div class="video">
          <iframe
            :src="
              dialog &&
              `https://www.youtube.com/embed/${getYoutubeCode(
                video
              )}?autoplay=1`
            "
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { getYoutubeCode } from "../../utils/getYoutubeCode";

export default {
  data: () => ({
    dialog: false,
  }),
  props: {
    video: String,
  },
  methods: {
    getYoutubeCode,
  },
};
</script>

<style lang="scss" scoped>
.video {
  .item-img {
    aspect-ratio: 16 / 9;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .item-caption {
    background-color: rgba(0, 0, 0, 0.4);
    bottom: 0;
    pointer-events: none;
    left: 0;
    opacity: 0.6;
    position: absolute;
    right: 0;
    top: 0;
    transition: all 0.1s linear;
  }

  &:hover {
    .item-caption {
      background-color: rgba(0, 0, 0, 0.1);
      opacity: 1;
    }
  }
}
</style>

<style lang="scss">
.video-content {
  margin-top: 60px !important;
  overflow-y: inherit !important;

  .close-dialog-button {
    position: absolute;
    right: 0;
    top: -60px;
  }
}
</style>
